// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3QoJvUhH17DF1A {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n._1z0WCIFWbnDOph {\n  width: unset;\n}\n._3deWQg3pIWkSF9 {\n  width: 200px;\n  z-index: 10;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardLink": "_3QoJvUhH17DF1A",
	"boardCard": "_1z0WCIFWbnDOph",
	"searchCard": "_3deWQg3pIWkSF9"
};
export default ___CSS_LOADER_EXPORT___;
